import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import useRequests from "../../Utils/useRequests";

// i18n
import { withTranslation } from "react-i18next";

const SidebarContent = (props) => {
  const ref = useRef();
  const { getRequest } = useRequests();

  const [type, setType] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  const handleLoadGetAdminInfo = async () => {
    const res = await getRequest("get-admin-info");
    if (res && res.code === 200) {
      setType(res.data.type);
    }
    setLoading(false);
  };

  // Load admin info once
  useEffect(() => {
    handleLoadGetAdminInfo();
  }, []);

  // Init menu after loading and pathname change
  useEffect(() => {
    if (loading) return; // stop here until sidebar fully rendered

    const pathName = props.location.pathname;

    const initMenu = () => {
      const menuElement = document.getElementById("side-menu");
      if (!menuElement) return; // avoid null crash

      new MetisMenu("#side-menu");

      let matchingMenuItem = null;
      const items = menuElement.getElementsByTagName("a");

      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }

      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };

    initMenu();
  }, [props.location.pathname, loading]);

  useEffect(() => {
    if (ref.current) ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");
        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active");
          parent3.childNodes[0].classList.add("mm-active");

          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-show");

            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show");
              parent5.childNodes[0].classList.add("mm-active");
            }
          }
        }
      }

      scrollElement(item);
    }
  }

  // Stop render until type loads (fixes redirect & crash)
  if (loading) {
    return null;
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>

            <li>
              <Link className="nav-link arrow-none" to={`/dashboard`}>
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link className="nav-link arrow-none" to="/jhalist">
                <i className="bx bx-task"></i>
                <span>{props.t("JHA")}</span>
              </Link>
            </li>


            {type === "admin" && (
              <>
              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-building"></i>
                  <span>{props.t("Organization")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/organization_management">{props.t("All Organization")}</Link>
                  </li>
                  <li>
                    <Link to="/add_organization">{props.t("Add Organization")}</Link>
                  </li>
                </ul>
              </li>

              <li>
                <Link to="/#" className="has-arrow">
                  <i className="bx bx-buildings"></i>
                  <span>{props.t("Company")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/company_management">{props.t("All Company")}</Link>
                  </li>
                  <li>
                    <Link to="/add_company">{props.t("Add Company")}</Link>
                  </li>
                </ul>
              </li>

              

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-file"></i>
                <span>{props.t("Contract")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/contract_management">{props.t("All Contract")}</Link>
                </li>
                <li>
                  <Link to="/add_contract">{props.t("Add Contract")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-briefcase"></i>
                <span>{props.t("Job Type")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/job_management">{props.t("All Job Type")}</Link>
                </li>
                <li>
                  <Link to="/add_job">{props.t("Add Job Type")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link className="nav-link arrow-none" to="/stky">
                <i className="bx bx-error"></i>
                <span>{props.t("Things that kill")}</span>
              </Link>
            </li>

            <li>
              <Link className="nav-link arrow-none" to="/special-equipment">
                <i className="bx bx-shield"></i>
                <span>{props.t("Special Equipment")}</span>
              </Link>
            </li>

            <li>
              <Link className="nav-link arrow-none" to="/rules-to-dig-by">
                <i className="bx bx-detail"></i>
                <span>{props.t("Rules to Dig By")}</span>
              </Link>
            </li>
            </>
            )}

            {type === "organization" && (
              <li>
                  <Link to="/#" className="has-arrow">
                    <i className="bx bx-user"></i>
                    <span>{props.t("Foremen")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/foremen_management">{props.t("All Foremen")}</Link>
                    </li>
                    <li>
                      <Link to="/add_foremen">{props.t("Add Foremen")}</Link>
                    </li>
                  </ul>
              </li>
            )}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
